// app/javascript/controllers/business_card_processing_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        processingId: String
    }

    connect() {
        // Store a reference to the bound function so we can remove it later
        this.boundHandleStartEvent = this.handleStartEvent.bind(this)

        // Listen for the custom event to start checking
        this.element.addEventListener('business-card-processing:start', this.boundHandleStartEvent)

        if (this.processingIdValue) {
            // Add a small delay to ensure everything is properly loaded
            setTimeout(() => {
                this.startStatusCheck()
            }, 500)
        }
    }

    handleStartEvent(event) {
        if (event.detail && event.detail.processingId) {
            this.processingIdValue = event.detail.processingId
            this.startStatusCheck()
        }
    }

    disconnect() {
        // Remove the event listener to prevent memory leaks
        if (this.boundHandleStartEvent) {
            this.element.removeEventListener('business-card-processing:start', this.boundHandleStartEvent)
        }

        this.stopStatusCheck()
    }

    startStatusCheck() {
        this.checkInterval = setInterval(() => {
            this.checkStatus()
        }, 5000)
    }

    stopStatusCheck() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval)
        }
    }

    async checkStatus() {
        try {
            const response = await fetch(`/business_cards/${this.processingIdValue}/status`)

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const contentType = response.headers.get("content-type")
            let data

            if (contentType && contentType.includes("application/json")) {
                data = await response.json()

                if (data.status === 'completed') {
                    this.stopStatusCheck()
                    window.location.href = `/business_cards/${this.processingIdValue}/confirm`
                } else if (data.status === 'failed') {
                    this.stopStatusCheck()
                    window.location.href = '/business_cards/new'
                } else {
                    console.log("Unknown status")
                }
            } else {
                console.error("Unexpected content type:", contentType)
            }
        } catch (error) {
            console.error("Error checking business card processing status:", error)
        }
    }
}
